import { render, staticRenderFns } from "./ObjectModal.vue?vue&type=template&id=60fc2796&"
import script from "./ObjectModal.vue?vue&type=script&lang=js&"
export * from "./ObjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports